
import { createContext, useState, useEffect } from "react";

export const AuthContext = createContext({
  token: null,
  user: null,
  login: () => {},
  logout: () => {},
});

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [user, setUser] = useState(null);
  useEffect(() => {
  const savedUser = localStorage.getItem("user");

  if (savedUser && savedUser !== "undefined" && savedUser !== "null") {
    try {
      setUser(JSON.parse(savedUser));
    } catch (err) {
      console.error("Invalid user JSON:", err);
      localStorage.removeItem("user");
    }
  }
}, []);


  const login = (token, userData) => {
    setToken(token);
    setUser(userData);

    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(userData));
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  };

  return (
    <AuthContext.Provider value={{ token, user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
